const CharacterCount = ({ id, count, maxLength }) => (
    <div id={id} className="input-character-count">
        {count.toLocaleString("en-GB")} / {maxLength.toLocaleString("en-GB")} characters
        {count >= maxLength && <span role="status"> — Character limit reached</span>}
    </div>
);

export default CharacterCount;
